import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

import { SmallScreenPanelZIndex } from "@/view/ContentLayout/ContentLayout.style";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const geniusAssignModalStyles: CSSObject = {
  root: {
    zIndex: 14,
    overflow: "scroll",

    [breakpoint.upTo(constants.breakpoints.BreakpointNames.md)]: {
      zIndex: SmallScreenPanelZIndex + 1,
    },
  },
  modalContentWrapper: {
    "&&": {
      maxWidth: "994px",
    },
  },
  scrollableBody: {
    flex: 1,
  },
};
